import type { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'

export type TransactionPaidToData = Awaited<
  ReturnType<typeof PayoutApiClient.getPayoutTransactions>
>['data']['transactions'][number]['paidTo']

export const getPaidTo = (data: TransactionPaidToData): string => {
  const paidTo: Record<TransactionPaidToData['type'], string> = {
    BANK_ACCOUNT: 'Bank account',
    CARD: 'Card',
    PARTNER: 'name' in data ? data.name : '-',
    UNKNOWN: '-',
    MANUAL: 'Manual transfer',
  }

  return paidTo[data.type]
}
